<footer class="navbar d-flex flex-column flex-lg-row justify-content-center p-4 mt-3">
  <span class="pe-md-1">{{ company_name }}</span>
  <span class="pe-md-1">
    &#169; {{ year }}. {{ 'all_rights_reserved' | translate: company_name }}
  </span>
  <a
    class="focus-visible"
    target="_blank"
    rel="noopener noreferrer"
    [href]="
      sanitizer.bypassSecurityTrustUrl('https://www.tangoe.com/client-services-privacy-notice/')
    "
  >
    {{ 'privacy_notice' | translate: company_name }}
  </a>
</footer>
